import isEqualObject from "fast-deep-equal"
import { watch } from "runed"

function useFormData(values = {}, onChange) {
	
	let initialValues = values
	let data = $state(values)
	let dirty = $derived(!isEqualObject(data, initialValues))

  let dataString = $derived(JSON.stringify(data))

  watch(() => dataString, () => {
    onChange?.(data)
  })

	return {
		initialValues,
		get data() { return data },
		get dirty() { return dirty },
    get string() { return dataString },
		reset: function() {
			data = Object.assign({}, initialValues)
		}
	}
}

export default useFormData
